export enum FilingTypeEnum {
  Patent = 0,
  Design = 1,
  Trademark = 2,
  UtilityModel = 3,
  Litigation = 4
}

export enum FilingTypeNameEnum {
  Patent = 'Patent',
  Design = 'Design',
  Trademark = 'Trademark',
  UtilityModel = 'Utility Model',
  Litigation = 'Litigation'
}

export function getFilingTypeName(filingTypeId: number) {
  switch(filingTypeId) {
    case FilingTypeEnum.Patent:
      return FilingTypeNameEnum.Patent;
    case FilingTypeEnum.Design:
      return FilingTypeNameEnum.Design;    
    case FilingTypeEnum.Trademark:
      return FilingTypeNameEnum.Trademark;    
    case FilingTypeEnum.UtilityModel:
      return FilingTypeNameEnum.UtilityModel;
    case FilingTypeEnum.Litigation:
      return FilingTypeNameEnum.Litigation;
    default:
      return "No Filing Type"
  }
}
